import './admin-user-form/admin-user-form.component';

import './admin-users-import-view/admin-users-import-view.component';
import './admin-users-import-view/admin-users-import-view.scss';

import './policy-password-view/policy-password-view.component';
import './policy-password-view/policy-password-view.scss';

import './policy-service-accounts-view/policy-service-accounts-view.component';
import './policy-service-accounts-view/policy-service-accounts-view.scss';

import './policy-users-view/policy-users-view.component';
import './policy-users-view/policy-users-view.scss';

import './policy-view/policy-view.component';
import './policy-view/policy-view.scss';

import './policy-token-view/policy-token-view.component';
import './policy-token-view/policy-token-view.scss';

import './role-list-item/role-list-item.component';
import './role-list-item/role-list-item.scss';

import './role-selection/role-selection.component';
import './role-selection/role-selection.scss';
